<template>
  <ValidationProvider :name="$attrs.label" :rules="rules" v-slot="{ errors, valid }">
    <v-autocomplete
        chips
        v-bind="$attrs"
        v-model="innerValue"
        v-on="$listeners"
        :error-messages="errors.concat($attrs.errors || [])"
        :items="items"
        :label="$t(`label.${$attrs.label}`)"
        :success="innerValue > 0 && valid"
    >
      <template v-slot:selection="data">
        <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
        >
          <v-avatar left v-if="'image' in data.item">
            <v-img :src="data.item.image || 'https://via.placeholder.com/24?text=3x4'"/>
          </v-avatar>
          {{ data.item.text }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar v-if="'image' in data.item">
          <v-img :src="data.item.image || 'https://via.placeholder.com/40?text=3x4'"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.text"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ""
    },
    items: {
      type: [Object, Array],
      default: []
    },
    // must be included in props
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: ""
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
